import React, { useState } from "react";
import styled from "styled-components";
import Modal from "../Kanban/Modal/Modal";
import { enqueueSnackbar } from "notistack";
import { useLanguage } from "../../Components/LangTranslation/LanguageContext";
import { useSession } from "../../authentications/SessionContext";
import { primaryColor } from "../../utilities/colors";

const ModalYesButton = styled.button`
  border-radius: 15px;
  background-color: ${(props) => (props.isVTEX ? "#000000" : "#ff5837")};
  color: ${(props) => (props.isVTEX ? primaryColor.primary : "#ffffff")};
  border: none;
  min-width: 100px;
  margin-right: 0px;
  cursor: pointer;
  height: 35px;
`;

const ModalNoButton = styled.button`
  border-radius: 15px;
  background-color: #f8f9fa;
  color: #b0b7c3;
  border: none;
  min-width: 100px;
  cursor: pointer;
  height: 35px;
`;
function useConfirmationModal() {
  const [openModal, setOpenModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [title, setTitle] = useState("");
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;

  const [metaData, setMetaData] = useState({
    primaryButton: "Yes",
    secondaryButton: "No",
    dangerouslySetInnerHTML: "",
    buttonWrapperClassName: "col d-flex justify-content-end gap-2",
  });

  const toggleModal = () => {
    setOpenModal(!openModal);
  };

  const ConfirmationModal = ({
    handleNo = toggleModal,
    handleYes = toggleModal,
  }) => {
    return (
      <Modal
        isOpen={openModal}
        onClose={() => !isDisabled && setOpenModal(false)}
      >
        <div
          className="container-fluid"
          style={{ minWidth: 300, maxWidth: 600 }}
        >
          <div className="row p-2 pt-4">
            <div className="col-12 mb-3">
              <h4 className="text-capitalize">
                {title || t["Are you sure you want to delete?"]}
              </h4>
              {metaData.dangerouslySetInnerHTML && (
                <>
                  <hr />
                  <div
                    className="col-12"
                    dangerouslySetInnerHTML={{
                      __html: metaData.dangerouslySetInnerHTML,
                    }}
                  />
                </>
              )}
            </div>

            <div className="col-12 d-flex">
              <div
                className={`col d-flex justify-content-end gap-2 ${metaData.buttonWrapperClassName}`}
              >
                {metaData.secondaryButton === "Ok" ? (
                  <ModalYesButton
                    disabled={isDisabled}
                    isVTEX={isVTEX}
                    onClick={handleNo}
                  >
                    {metaData.secondaryButton}
                  </ModalYesButton>
                ) : (
                  <ModalNoButton disabled={isDisabled} onClick={handleNo}>
                    {metaData.secondaryButton}
                  </ModalNoButton>
                )}
                {metaData.primaryButton && (
                  <ModalYesButton
                    disabled={isDisabled}
                    isVTEX={isVTEX}
                    onClick={handleYes}
                  >
                    {metaData.primaryButton}
                  </ModalYesButton>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  return {
    ConfirmationModal,
    openModal,
    setOpenModal,
    title,
    setTitle,
    isDisabled,
    setIsDisabled,
    metaData,
    setMetaData,
    toggleModal,
  };
}

export default useConfirmationModal;
